import { combineReducers } from "redux";
import { reducer as reduxFormReducer } from "redux-form";
import authentication from "./authentication.reducer";
import home from "./home.reducer";
import productList from "./product_list.reducer";
import topProducts from "./top_product_list.reducer";
import productSearchList from "./product_search_list.reducer";
import productDetails from "./product_details.reducer";
import insuranceList from "./insuarance_list.reducer";
import zipData from "./zipdata.reducer";
import retailPrice from "./retail_price.reducer";
import discountPrice from "./discount_price.reducer";
import copayPrice from "./copay_price.reducer";
import couponPrice from "./coupon_price.reducer";
import alternateList from "./alternate_list.reducer";
import brandDetails from "./brand_details.reducer";
import brandDetailsNew from "./brand_details_new.reducer";
import genericList from "./generic_list.reducer";
import genericDetails from "./generic_details.reducer";
import recentSearch from "./recent_search_list.reducer";
import signIn from "./signin_reducer";
import signOut from "./signout_reducer";
import signUp from "./signup_reducer";
import forgotPassword from "./forgot_password_reducer";
import messages from "./messages_list_reducer";
import myCoupons from "./mycoupons_reducer";
import deleteCouponInfo from "./delete_coupon_reducer";
import profile from "./profile_reducer";
import contactUs from "./contact_us_reducer";
import cuverdSettings from "./cuverd_settings_reducer";
import notifications from "./notifications_reducer";
import clearRecent from "./clear_recent_reducer";
import verifyForgotPassword from "./verify_forgot_password_reducer";
import verifyPasswordInfo from "./verify_password_change_reducer";
import changePhonenumberVerify from "./verify_phonenumber_change_reducer";
import changeEmailVerify from "./verify_email_change_reducer";
import contentType from "./content_type_reducer";
import changeEmail from "./change_email_reducer";
import changePhone from "./change_phone_reducer";
import changePassword from "./change_password_reducer";
import accountResendInfo from "./account_resend_attempt_reducer";
import forgotLoginPassword from "./login_forgot_password_reducer";
import resendForgotLoginPassword from "./login_forgot_password_resend_reducer";
import verifyForgotLoginPassword from "./login_forgot_password_verify_reducer";
import verifyResendPassword from "./verify_resend_password_change_reducer";
import searchRadius from "./search_radius_reducer";
import savedCouponInfo from "./save_coupon_reducer";
import reminderTimeZone from "./reminder_timezone_reducer";
import reminderDates from "./reminder_dates_reducer";
import savedDoseReminderInfo from "./save_dose_reminder_reducer";
import doseReminderDetails from "./dose_reminder-data.reducer";
import refillSavingsDetails from "./refill_savings_data.reducer";
import savedRefillReminderInfo from "./save_refill_reminder_reducer";
import sendEmailMessageInfo from "./send_email_message_reducer";
import sendTextMessageInfo from "./send_text_message_reducer";
import sendHcpTextMessageInfo from "./send_hcp_text_message_reducer";
import messagesCount from "./messages_count_reducer";
import messageRead from "./message_mark_as_read_reducer";
import messageDelete from "./message_delete_reducer";
import messagesMarkAllRead from "./message_mark_all_as_read_reducer";
import messagesDeleteAll from "./message_delete_all_reducer";
import notificationSettings from "./notifications_settings_reducer";
import validateCouponInfo from "./validate_coupon_reducer";
import userInsurance from "./save_user_insurance_reducer";
import insuranceInfo from "./insurance_detail_reducer";
import globalStoreInfo from "./global_store_reducer";
import playstoreInfo from "./playstore.reducer";
import preferredCommInfo from "./get_preferred_communication_reducer";
import savedPreferredCommInfo from "./save_preferred_communication_reducer";
import savedZipData from "./save_zipdata.reducer";
import gtmInfo from "./gtm_store_reducer";
import deviceInfo from "./device_info_reducer";
import appIdentity from "./app_identity_reducer";
import organizationInfo from "./organization_reducer";
import organizationLogo from "./organization_logo_reducer";
import pharmacyGroupList from "./pharmacy_group_list_reducer";
import prescriptions from "./prescriptions_reducer";

const rootReducer = combineReducers({
  form: reduxFormReducer,
  authentication,
  home,
  productList,
  topProducts,
  productSearchList,
  productDetails,
  insuranceList,
  zipData,
  retailPrice,
  discountPrice,
  copayPrice,
  couponPrice,
  alternateList,
  brandDetails,
  brandDetailsNew,
  genericList,
  genericDetails,
  recentSearch,
  signIn,
  signOut,
  signUp,
  forgotPassword,
  messages,
  myCoupons,
  deleteCouponInfo,
  profile,
  contactUs,
  cuverdSettings,
  notifications,
  clearRecent,
  verifyForgotPassword,
  verifyPasswordInfo,
  changePhonenumberVerify,
  changeEmailVerify,
  contentType,
  changeEmail,
  changePhone,
  changePassword,
  accountResendInfo,
  forgotLoginPassword,
  resendForgotLoginPassword,
  verifyForgotLoginPassword,
  verifyResendPassword,
  searchRadius,
  savedCouponInfo,
  reminderTimeZone,
  reminderDates,
  savedDoseReminderInfo,
  doseReminderDetails,
  refillSavingsDetails,
  savedRefillReminderInfo,
  sendEmailMessageInfo,
  sendTextMessageInfo,
  sendHcpTextMessageInfo,
  messagesCount,
  messageRead,
  messageDelete,
  messagesMarkAllRead,
  messagesDeleteAll,
  notificationSettings,
  validateCouponInfo,
  userInsurance,
  insuranceInfo,
  globalStoreInfo,
  playstoreInfo,
  preferredCommInfo,
  savedPreferredCommInfo,
  savedZipData,
  gtmInfo,
  deviceInfo,
  appIdentity,
  organizationInfo,
  organizationLogo,
  pharmacyGroupList,
  prescriptions,
});

export default rootReducer;
